import { createCRUDEndpoints } from '@/api/factory/crud';
import { PublicSiteJSON } from '@/store/modules/treatments/public-site';

type ListParams = { status?: string | number } | undefined;

export const { list, get, store, remove, restore } = createCRUDEndpoints<PublicSiteJSON, ListParams>({
  slug: 'public_site',
});
